module.exports = __webpack_public_path__ + "static/media/nisai-intro.dc0e2b6c.png";